module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"addedToWishlist":"%{productName} has been added to your Wish List"},"lng_id":{"addedToWishlist":"%{productName} ditambahkan ke Wish List"},"lng_th":{"addedToWishlist":"เพิ่ม %{productName} ในรายการสินค้าที่อยากได้แล้ว"},"lng_zh":{"addedToWishlist":"%{productName}已被添加至願望清單"},"lng_ko":{"addedToWishlist":"%{productName}을(를) 위시리스트에 담았습니다. "}}')
  delete Component.options._Ctor
}
